<template>
  <div class="p-4">
    <ul class="space-y-2" role="list">
      <Shop
        v-for="(shop, index) in shops"
        :key="index"

        @remove="removeShop(index)"
        @save="updatedShop => saveShop(updatedShop, index)"
        v-bind="shop"
      />
    </ul>
    <NewShop class="mt-4" @add="addShop"/>
  </div>
</template>

<script>

import NewShop from "./NewShop"
import Shop from "./Shop"

export default {
  props: ['config', 'role', 'configuration', 'id'],
  components: {
    Shop,
    NewShop,
  },
  data() {
    return {
      shops: (this.config && this.configuration && this.config[this.configuration.id]) || this.default || [],
    }
  },
  methods: {
    addShop(shop) {
      this.shops.push(shop)
      this.shops = [...this.shops]
      this.update()
    },
    removeShop(index) {
      this.shops.splice(index, 1)
      this.shops = [...this.shops]
      this.update()
    },
    saveShop(updated, index) {
      this.shops.splice(index, 1, updated)
      this.shops = [...this.shops]
      this.update()
    },
    update() {
      const config = { ...this.config }
      config[this.configuration.id] = this.shops

      this.$store.dispatch('editor/setBlockConfig', {
        id: this.id,
        role: this.role,
        config,
      })
    },
  },
}

</script>
